import LoginView from './../LoginView.vue'

export const loginRoute = [
  {
    path: '/',
    alias: ['/login', '/signin'],
    name: 'login',
    component: LoginView
  },
  {
    path: '/logout',
    name: 'logout',
    alias: '/logout'
  }

]
